import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Cons1.css';

const fitItems = [
    'סטארטאפים שצריכים בסיס טכנולוגי נכון כבר מהשלבים הראשונים.',
    'עסקים בצמיחה שהמערכות או תהליכי הפיתוח כבר לא עומדים בקצב.',
    'חברות שבנו מערכת במהירות וכעת צריכות לייצב, לסדר ולהכין אותה להמשך.',
    'ארגונים בינוניים שיש בהם צוות או ספקים, אבל חסרה הנהגה טכנולוגית ברורה.'
];

const problemItems = [
    'הפיתוח איטי מדי והתקדמות מרגישה כבדה.',
    'יש תקלות חוזרות או חוסר יציבות במערכת.',
    'כל שינוי קטן מייצר סיכון מיותר.',
    'המערכת עובדת, אבל לא באמת מוכנה לצמיחה.',
    'עלויות ענן ותשתיות עולות בלי שליטה מספקת.',
    'אין סטנדרטים ברורים לפיתוח, תשתיות ותהליכי עבודה.',
    'יש תלות גבוהה מדי בספקים או במפתחים בודדים.',
    'אין גורם שמוביל החלטות טכנולוגיות ברמה גבוהה.'
];

const audienceSignals = [
    'בניתם מהר כדי להגיע לשוק, ועכשיו צריך לעשות סדר.',
    'העסק גדל והמערכות כבר לא תומכות בקצב.',
    'יש צוות או ספקים, אבל אין ראייה טכנולוגית רחבה שמובילה אותם.'
];

const services = [
    {
        icon: 'fas fa-compass-drafting',
        title: 'אסטרטגיה וכיוון טכנולוגי',
        text: 'מגדירים כיוון ברור שמחבר בין היעדים העסקיים לבין ההחלטות הטכנולוגיות שצריך לקבל עכשיו.'
    },
    {
        icon: 'fas fa-magnifying-glass-chart',
        title: 'ניתוח מצב קיים',
        text: 'ממפים מערכות, תשתיות ותהליכים כדי להבין מה עובד, מה מסכן, ואיפה צריך להתערב.'
    },
    {
        icon: 'fas fa-sitemap',
        title: 'תכנון ארכיטקטורה ותשתית',
        text: 'בונים מסגרת נכונה ליציבות, ביצועים ו-Scaling, בלי לייצר מורכבות מיותרת.'
    },
    {
        icon: 'fas fa-people-arrows',
        title: 'ליווי מעשי בקבלת החלטות',
        text: 'מלווים צמתים חשובים, עבודה מול ספקים והובלת תהליכים, עם הסתכלות בכירה ומעשית.'
    }
];

const outcomes = [
    'מערכת יציבה יותר ותהליכי עבודה מסודרים יותר.',
    'תשתית שמתאימה לצמיחה ולא רק לצורך המיידי.',
    'פחות טעויות יקרות ופחות תיקונים מאוחרים.',
    'יותר ביטחון בקבלת החלטות טכנולוגיות.',
    'שיפור בביצועים, בקצב ההתקדמות ובשליטה.',
    'פחות תלות באנשים בודדים ויותר בהירות ארגונית.'
];

const processSteps = [
    {
        number: '01',
        title: 'שיחת היכרות',
        text: 'מבינים את הצורך העסקי, האתגרים והיעדים.'
    },
    {
        number: '02',
        title: 'ניתוח מצב קיים',
        text: 'בוחנים מערכות, תשתיות, תהליכים ותלויות.'
    },
    {
        number: '03',
        title: 'בניית כיוון',
        text: 'מגדירים סדרי עדיפויות ותוכנית פעולה ברורה.'
    },
    {
        number: '04',
        title: 'ליווי ביישום',
        text: 'מלווים את ההתקדמות כדי לחבר בין החלטה לתוצאה.'
    }
];

const trustPoints = [
    'ניסיון רחב בפיתוח תוכנה, תשתיות, DevOps וענן.',
    'גישה פרקטית שמכוונת לביצוע, לא רק להמלצות.',
    'חיבור בין צרכים עסקיים להחלטות טכנולוגיות.',
    'ליווי שמותאם לשלב שבו החברה נמצאת.'
];

const bookingUrl = 'https://meetings.hubspot.com/viacheslav-seifer';

const ConsultingSolutionsOffer = () => {
    const scrollToForm = () => {
        const formElement = document.getElementById('epic-consulting-form');
        if (formElement) {
            formElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };

    useEffect(() => {
        AOS.init({
            duration: 900,
            once: true
        });
    }, []);

    return (
        <section className="consulting-solutions-offer py-5">
            <div className="container">
                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-xl-10">
                        <div className="consulting-hero-card text-center">
                            <span className="badge bg-primary mb-3">ייעוץ וליווי טכנולוגי</span>
                            <h2 className="display-5 fw-bold mb-3">
                                ייעוץ טכנולוגי לעסקים שרוצים לגדול בלי לשלם על טעויות בדרך
                            </h2>
                            <p className="lead text-muted mb-4">
                                תכנון נכון של מערכות, תשתיות ותהליכי פיתוח כדי לאפשר צמיחה יציבה,
                                קבלת החלטות בטוחה יותר והתקדמות מסודרת.
                            </p>
                            <div className="consulting-cta-row">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-lg"
                                    onClick={scrollToForm}
                                >
                                    השאר פרטים
                                </button>
                                <a
                                    href={bookingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-primary btn-lg"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-xl-10">
                        <div className="service-content consulting-content-block">
                            <div className="section-heading">
                                <span className="section-kicker">למי זה מתאים</span>
                                <h3 className="h2 fw-bold">ליווי טכנולוגי שמחובר למציאות העסקית</h3>
                            </div>
                            <div className="consulting-list-grid">
                                {fitItems.map((item) => (
                                    <div key={item} className="consulting-list-card">
                                        <i className="fas fa-check-circle"></i>
                                        <p>{item}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-xl-10">
                        <div className="service-content consulting-content-block">
                            <div className="section-heading">
                                <span className="section-kicker">האם זה נשמע מוכר?</span>
                                <h3 className="h2 fw-bold">המערכת קיימת, אבל התשתית לצמיחה עדיין לא</h3>
                            </div>
                            <div className="consulting-problem-grid">
                                {problemItems.map((item) => (
                                    <div key={item} className="consulting-problem-item">
                                        <i className="fas fa-angle-left"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-xl-10">
                        <div className="audience-match-card">
                            <div className="section-heading text-center">
                                <span className="section-kicker">זה כנראה המצב אצלכם</span>
                                <h3 className="h2 fw-bold">אם המשפטים האלה מרגישים מדויקים, זה העמוד בשבילכם</h3>
                            </div>
                            <div className="row g-4">
                                {audienceSignals.map((item) => (
                                    <div key={item} className="col-md-4">
                                        <div className="audience-signal-card h-100">
                                            <p>{item}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="audience-match-note">
                                <strong>גם לארגונים בינוניים:</strong> אם אין אצלכם גורם פנימי שמוביל החלטות
                                טכנולוגיות ברמה גבוהה, אנחנו נכנסים עם הסתכלות בכירה, שיקול דעת וליווי
                                מעשי בלי להעמיס על הארגון משרה מלאה נוספת.
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-xl-10">
                        <div className="section-heading text-center mb-4">
                            <span className="section-kicker">איך אנחנו עוזרים</span>
                            <h3 className="h2 fw-bold">מכניסים סדר, כיוון ושיקול דעת לתוך המערך הטכנולוגי</h3>
                        </div>
                        <div className="row g-4">
                            {services.map((service) => (
                                <div key={service.title} className="col-md-6">
                                    <div className="service-content consulting-service-card h-100">
                                        <div className="service-icon consulting-service-icon">
                                            <i className={service.icon}></i>
                                        </div>
                                        <h4 className="h5 fw-bold mb-3">{service.title}</h4>
                                        <p className="text-muted mb-0">{service.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-xl-10">
                        <div className="approach-card">
                            <div className="section-heading text-center mb-4">
                                <span className="section-kicker">מה יוצא לכם מזה</span>
                                <h3 className="h2 fw-bold">יותר יציבות, יותר שליטה, פחות טעויות יקרות</h3>
                            </div>
                            <div className="consulting-outcomes-grid">
                                {outcomes.map((item) => (
                                    <div key={item} className="consulting-outcome-item">
                                        <i className="fas fa-arrow-left"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-xl-10">
                        <div className="section-heading text-center mb-4">
                            <span className="section-kicker">איך זה עובד</span>
                            <h3 className="h2 fw-bold">תהליך פשוט וברור</h3>
                        </div>
                        <div className="row g-4">
                            {processSteps.map((step) => (
                                <div key={step.number} className="col-md-6 col-xl-3">
                                    <div className="process-step-card h-100">
                                        <span className="process-step-number">{step.number}</span>
                                        <h4 className="h6 fw-bold mb-3">{step.title}</h4>
                                        <p className="text-muted mb-0">{step.text}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center mb-5" data-aos="fade-up">
                    <div className="col-xl-10">
                        <div className="service-content consulting-content-block">
                            <div className="section-heading">
                                <span className="section-kicker">למה לעבוד איתנו</span>
                                <h3 className="h2 fw-bold">ניסיון רחב וגישה פרקטית שמחוברת לביצוע</h3>
                            </div>
                            <div className="consulting-trust-grid">
                                {trustPoints.map((item) => (
                                    <div key={item} className="consulting-trust-item">
                                        <i className="fas fa-shield-alt"></i>
                                        <span>{item}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center" data-aos="zoom-in">
                    <div className="col-xl-10">
                        <div className="cta-card text-center p-5 text-white">
                            <h3 className="h2 fw-bold mb-3">אם צריך יותר סדר, יציבות וביטחון בהחלטות הטכנולוגיות, זה הזמן לדבר</h3>
                            <p className="lead mb-4">
                                שיחה אחת יכולה לעזור לכם להבין מה מעכב, מה מסכן, ואיזה כיוון נכון
                                לבנות מכאן והלאה.
                            </p>
                            <div className="consulting-cta-row consulting-cta-row--light mb-3">
                                <button type="button" className="btn btn-light btn-lg" onClick={scrollToForm}>
                                    דברו עם מומחה
                                </button>
                                <a
                                    href={bookingUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="btn btn-outline-light btn-lg"
                                >
                                    קבעו שיחת ייעוץ
                                </a>
                            </div>
                            <p className="cta-note mb-0">שיחה ראשונית ללא התחייבות. חזרה תוך 24 שעות.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ConsultingSolutionsOffer;
